import classNames from 'classnames';
import React from 'react';
import * as styles from './Card.module.scss';
import NestableLink from '../utils/NestableLink';
import PopOver from './deprecated/PopOver';

export const CardSeparator = () => <hr className={styles.separator} />;

interface CardsProps {
  children: React.ReactNode;
}

export const Cards = ({ children }: CardsProps) => (
  <div className={styles.cards}>{children}</div>
);

type CardProps = {
  asPopOver?: boolean;
  children: React.ReactNode;
  to?: string;
  onClick?: () => void;
  noPadding?: boolean;
  newTab?: boolean;
  popOverContainerProps?: React.ComponentProps<typeof PopOver.Container>;
  'aria-label'?: string;
} & Partial<
  Pick<
    React.ComponentProps<typeof NestableLink>,
    'onClick' | 'to' | 'ignoreInsideLinks'
  >
>;

const Card = ({
  asPopOver = false,
  children,
  ignoreInsideLinks,
  noPadding = false,
  onClick,
  popOverContainerProps,
  to,
  'aria-label': ariaLabel,
  newTab,
}: CardProps) => {
  const innerClassName = classNames(styles.card, {
    [styles.asPopOver]: asPopOver,
    [styles.clickable]: (to || onClick) && !asPopOver,
    [styles.noPadding]: noPadding,
  });

  let inner = <div className={innerClassName}>{children}</div>;

  if (to) {
    inner = (
      <NestableLink
        className={innerClassName}
        ignoreInsideLinks={ignoreInsideLinks}
        onClick={onClick}
        newTab={newTab}
        to={to}
        aria-label={ariaLabel}
      >
        {children}
      </NestableLink>
    );
  } else if (onClick) {
    inner = (
      <button className={innerClassName} onClick={onClick} type="button">
        {children}
      </button>
    );
  }

  return asPopOver ? (
    <PopOver.Container noPadding width="wide" {...popOverContainerProps}>
      {inner}
    </PopOver.Container>
  ) : (
    inner
  );
};

export default Card;
